<template>
  <div class="ai_diagnosis_warp" v-loading="loading">
    <div class="ai_diagnosis_warp_title">
      <div>语音病例</div>
      <i class="el-icon-close" @click="close"></i>
    </div>
    <div class="ai_diagnosis_warp_content" v-if="diagnosis.records && !diagnosis.records.ERRText">
      <div class="content_item" v-for="(value, key) in diagnosis.records" :key="key">
        <div class="content_item_label">{{ key }}：</div>
        <div class="content_item_value">{{ value }}</div>
      </div>
    </div>
    <div class="ai_diagnosis_warp_content" v-if="diagnosis.records && diagnosis.records.ERRText">
      {{ diagnosis.records.ERRText }}
    </div>
    <div class="ai_diagnosis_warp_bottom" v-if="diagnosis.records && !diagnosis.records.ERRText">
      <div class="ai_diagnosis_warp_btn" @click="adopt">采纳</div>
    </div>
  </div>
</template>
<script>
import { track } from '@/api/voice';
import { fetchSSE } from '@/utils/sseService';
export default {
  props: {
    diagnosisParams: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      eventSource: null,
      message: '',
      diagnosis: {
        records: {},
        notes: []
      },
      loading: false,
    }
  },
  watch:{
    diagnosisParams:{
      handler(newValue) {
        this.diagnosisParams = newValue;
        this.connectSSE();
      }
    }
  },
  async created() {
    this.connectSSE();
  },
  methods: {
    async connectSSE() {
      this.loading = true;
      await fetchSSE.connect(
        `${process.env.VUE_APP_API_URL}/aimatrix/doctor-assist/med-rec`,
        this.diagnosisParams,
        {
          onMessage: (data, eventType) => {
            this.message = this.message + data
            this.message = this.message.replaceAll('data:', '')
            this.diagnosis = this.handleMessage(this.message);
            this.loading = false;
          },
          onError: (err) => {
            this.loading = false;
          },
          onComplete: () => {
            console.log('SSE连接完成', this.message.replaceAll('data:', ''));
          }
        }
      );
    },
    disconnect() {
      fetchSSE.disconnect();
      this.loading = false;
    },
    handleMessage(text) {
      const result = {
        records: {},
        notes: []
      };

      // 先分离注释部分
      const noteMatch = text.match(/（注：[^\n]*）/g);
      if (noteMatch) {
        result.notes = noteMatch.map(note => note.replace(/^（注：|）$/g, ''));
      }
      if(text.includes('ERR::')){
        result.records.ERRText = '语音病历解析未完成，请检查录音质量或尝试重新录制。'
      }
      // 提取病历部分
      const sections = text.split('##').filter(section => section.trim());

      sections.forEach(section => {
        const [title, ...contentParts] = section.split('\n');
        let content = contentParts.join('\n').trim();

        // 移除可能包含的注释
        content = content.replace(/（注：[^\n]*）/, '').trim();

        if (title && content !== undefined) {
          result.records[title.trim()] = content;
        }
      });
      console.log(result,8787878);
      
      return result;
    },
    close() {
      this.$emit('close')
    },
    adopt() {
      let trackParams = {
        companyId: this.diagnosisParams.companyId,
        userId: this.diagnosisParams.userId,
        diagnosisId: this.diagnosisParams.diagnosisId,
        medRecord: this.message
      }
      track(trackParams)
      this.$emit('adopt', this.diagnosis)
    }
  }
}
</script>
<style lang="less" scoped>
.ai_diagnosis_warp {
  height: 100%;
  background: linear-gradient(180deg, #DFEFFE 0%, #FFFFFF 70%);
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding-bottom: 20px;
  box-sizing: border-box;

  .ai_diagnosis_warp_title {
    height: 54px;
    font-weight: 500;
    font-size: 16px;
    color: #291D22;
    padding: 0 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
  }

  .ai_diagnosis_warp_content {
    flex: 1;
    padding: 20px 24px;
    box-sizing: border-box;
    overflow: auto;

    .content_item {
      display: flex;
      align-items: flex-start;

      .content_item_label {
        width: 80px;
        text-align: right;
        font-weight: 500;
        font-size: 16px;
        color: #000000;
        flex-shrink: 0;
        padding-top: 4px;
      }

      .content_item_value {
        font-weight: 400;
        font-size: 16px;
        color: #1D2129;
        line-height: 24px;
      }
    }
  }

  .ai_diagnosis_warp_bottom {
    padding: 0 24px;

    .ai_diagnosis_warp_btn {
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #1D90FD;
      border-radius: 100px 100px 100px 100px;
      font-weight: 500;
      font-size: 14px;
      color: #FFFFFF;
      cursor: pointer;
    }
  }
}
</style>